module.exports = __webpack_public_path__ + "img/teacher.682e49cb.svg";